import { createI18n } from "vue-i18n"
import no from "./no.json"

export type MessageSchema = typeof no
export type SupportedLocale = "no"

// Norwegian only for now
export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: "no",
  fallbackLocale: "no",
  messages: { no },
  globalInjection: true,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV
})

export default i18n
